// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__YOLP9","link":"tweet-replies_link__Yp9rn","text":"tweet-replies_text___AX7v"};